const resolveUserAgent = (userAgent) => {
  if (typeof userAgent === 'string' && userAgent.length > 0) {
    return userAgent
  }
  return navigator.userAgent
}

export const isWeChatBrowser = (userAgent) => {
  const resolvedUserAgent = resolveUserAgent(userAgent)
  return /MicroMessenger/i.test(resolvedUserAgent)
}

export const isStandaloneQQBrowser = (userAgent) => {
  const resolvedUserAgent = resolveUserAgent(userAgent)
  return /MQQBrowser/i.test(resolvedUserAgent) && !/\bQQ\//i.test(resolvedUserAgent)
}

export const isQQInAppWebView = (userAgent) => {
  const resolvedUserAgent = resolveUserAgent(userAgent)
  return /\bQQ\//i.test(resolvedUserAgent)
}

export const shouldShowBrowserMask = (userAgent) => {
  const resolvedUserAgent = resolveUserAgent(userAgent)
  if (isStandaloneQQBrowser(resolvedUserAgent)) {
    return false
  }
  return isWeChatBrowser(resolvedUserAgent) || isQQInAppWebView(resolvedUserAgent)
}
